// File: /src/pages/IssuedCertificates.js
import React, { useEffect, useState } from 'react';
import './IssuedCertificates.css';
import { getAllVCs } from '../../api/ssiAPI';
import { FaCheckCircle, FaCertificate, FaBan, FaEye, FaEdit, FaTrash } from 'react-icons/fa';
import { getMe } from '../../api/loginAPI';
import { useNavigate } from 'react-router-dom';

function IssuedCertificates() {
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');

 const [allCertificates, setAllCertificates] = useState([]);

  const [user, setUser] = useState(null);
 
     const darkMode = document.body.classList.contains('dark-mode')
   
 useEffect(() => {
  async function fetchUserAndVCs() {
    try {
      const userData = await getMe();
      console.log('UserData', userData);
      setUser(userData);

      if (userData?.Id) {
        const data = await getAllVCs(userData.Id);
        if (Array.isArray(data?.response)) {
          setAllCertificates(data.response);
        } else {
          console.error('Unexpected response format:', data);
          setAllCertificates([]);
        }
      }
    } catch (err) {
      console.error('❌ Failed to fetch user or VCs:', err);
    }
  }

  fetchUserAndVCs();
}, []);


const filteredCertificates = allCertificates.filter(cert => {
  const certDate = new Date(cert.createdAt);
  const from = startDate ? new Date(startDate) : null;
  const to = endDate ? new Date(endDate) : null;
  return (!from || certDate >= from) && (!to || certDate <= to);
});

const navigate = useNavigate();

const handleView = (id) => {
  navigate(`/certificate/view/${id}`);
};

  const handleEdit = (id) => {
    alert(`Editing certificate ${id}`);
  };

  const handleDelete = (id) => {
    alert(`Deleting certificate ${id}`);
  };

const totalIssued = allCertificates.length;
const activeCount =  allCertificates.length;
const revokedCount =  "0";


  return (
    <div className="page issued-layout">
      <h2 className="issued-title">Issued Certificates</h2>

      <div className="card-row">
        <div className="report-card issued">
          <FaCertificate className="card-icon" />
          <div>
            <h3>{totalIssued}</h3>
            <p>Total Issued</p>
          </div>
        </div>
        <div className="report-card active">
          <FaCheckCircle className="card-icon" />
          <div>
            <h3>{activeCount}</h3>
            <p>Active Certificates</p>
          </div>
        </div>
        <div className="report-card revoked">
          <FaBan className="card-icon" />
          <div>
            <h3>{revokedCount}</h3>
            <p>Revoked Certificates</p>
          </div>
        </div>
      </div>

      <div className="filters">
        <label>
          Start Date:
          <input type="date" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
        </label>
        <label>
          End Date:
          <input type="date" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
        </label>
      </div>

      <div className="table-section">
        <table>
          <thead>
            <tr>
              <th>Sr No</th>
              <th>Issued To</th>
              <th>Certificate Name</th>
              <th>Date of Issuance</th>
              <th className="icon-col">View</th>
              {/* <th className="icon-col">Edit</th>
              <th className="icon-col">Revoke</th> */}
            </tr>
          </thead>
          <tbody>
  {filteredCertificates.map((cert, index) => {
    const subject = cert.vc.credentialSubject[0] || {};
    const issuanceDate = cert.vc.issuanceDate || cert.createdAt;

    return (
      <tr key={cert._id}>
        <td>{index + 1}</td>
        <td>{subject.name || 'N/A'}</td>
        <td>{subject.certificateName || 'N/A'}</td>
        <td>{new Date(issuanceDate).toLocaleDateString()}</td>
        <td className="icon-col">
          <FaEye className="table-icon icon-view" onClick={() => handleView(cert._id)} />
        </td>
        {/* <td className="icon-col">
          <FaEdit className="table-icon icon-edit" onClick={() => handleEdit(cert._id)} />
        </td>
        <td className="icon-col">
          <FaTrash className="table-icon icon-delete" onClick={() => handleDelete(cert._id)} />
        </td> */}
      </tr>
    );
  })}
</tbody>

        </table>
      </div>
    </div>
  );
}

export default IssuedCertificates;
